module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"WidgetEditorContentArea":{"placeholder":"Drop any here"}},"en_us":{"WidgetEditorContentArea":{"placeholder":"Drop any here"}}}')
  delete Component.options._Ctor
}
